import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SimpleReponseResult,Profil, DebugParam } from '../all-models';
import { SharedDataService,PafListsService } from '../all-services';


@Injectable({
  providedIn: 'root'
})
export class DebugService {

  debugUrl: string;
  
  constructor(private http: HttpClient, 
    public sharedDataSvc: SharedDataService) { 
      this.debugUrl = this.sharedDataSvc.apiBaseUrl+'/Debug';
    }
    
  get lstProfils():Profil[] {
    return this.sharedDataSvc.lstProfils || [];
  }
  get debugParam() : DebugParam {
    return this.sharedDataSvc.debugParam;
  }

  get selectedProfil():Profil{
    return this.lstProfils.find(p=>p.Id==this.debugParam.ProfilId);
  }
  set selectedProfil(p:Profil){
   this.debugParam.ProfilId = (p? p.Id : 0);
  }
  
  get selectedProfilId(): string{
    return this.selectedProfil?.Id?.toString()|| '';
  }
  set selectedProfilId(id:string){
    if (id){
     this.ChangeProfil(Number.parseInt(id))
     .subscribe((result:SimpleReponseResult)=>{
       if (result.Ok){
         this.debugParam.ProfilId=result.Id;
         let profil:Profil=this.lstProfils.find(p=>p.Id==result.Id);
         this.sharedDataSvc.loggedProfilSubject.next(profil);
       }
     });
    } else {
      this.debugParam.ProfilId = 0;
    }
  }
  
  public Activate(profil2select?:number): Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(this.debugUrl+'/Activate',null)
    .pipe(tap((result:SimpleReponseResult)=>{
      let profil:Profil;
      if (result.Ok) {
        if (this.debugParam.ProfilId==null){
          if (this.sharedDataSvc.portalType=='EXTRANET'){
            profil = this.lstProfils.find(p=>p.Cod=='FOURNISSEUR');
          } else {
            profil = this.sharedDataSvc.loggedIntUser?.Profil;
          }
        } else {
          profil = this.lstProfils.find(p=>p.Id==this.debugParam.ProfilId);
        }
      } 
      this.debugParam.DebugActif=1;
      if (!profil2select){
      this.selectedProfilId=(profil?.Id||0).toString();            
      } else {
        this.selectedProfilId=profil2select.toString();
      }
    }));
  }

  public Desactivate(): Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(this.debugUrl+'/Desactivate',null)
    .pipe(tap(res=>{
      let profil:Profil;
      if (this.sharedDataSvc.portalType=='EXTRANET'){
        profil = this.lstProfils.find(p=>p.Cod=='FOURNISSEUR');
      } else {
        profil = this.sharedDataSvc.loggedIntUser?.Profil;
      }
      this.selectedProfilId=(profil?.Id||0).toString();
    }));
  }
  public ChangeProfil(profilId:number): Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(this.debugUrl+`/ChangeProfil/${profilId}`,null);
  }

  get isActif():boolean{
    return this.debugParam.DebugActif==1;
  }
  
  set isActif(value:boolean) {
    if (value!=(this.debugParam.DebugActif==1)){
      if (value){
        this.Activate()
        .subscribe((result:SimpleReponseResult)=>{
          if (result.Ok){
            this.debugParam.DebugActif=1;
            this._initProfilFromLoggedUser();
          }
        });
      } else {
        this.Desactivate()
        .subscribe((result:SimpleReponseResult)=>{
          if (result.Ok){
            this.debugParam.DebugActif=0;
          }
        });

      }
    }
    this.debugParam.DebugActif = (value ? 1: 0);
  }
  
    private  _reinit():void{
      this.debugParam.DebugActif=1;
      this.isActif = false;
    }
  
  private _initProfilFromLoggedUser():void{
    if (this.debugParam.ProfilId) return;
    if (this.sharedDataSvc.portalType=='EXTRANET'){
      this.selectedProfilId= (this.lstProfils.find(p=>p.Cod=='FOURNISSEUR')?.Id ||0).toString();
    } else {
      this.selectedProfilId= (this.sharedDataSvc.loggedIntUser?.ProfilId || 0).toString();
    }
  }

}
